exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TableForm.ui.form .fields{width:60%;min-width:300px;margin:0 auto}.TableForm.ui.form .fields.TableForm__actions{justify-content:space-around;margin-bottom:1.5em}.TableForm.ui.form .fields.TableForm__actions .checkbox{margin-bottom:1em}", ""]);

